<template>
  <main>
    <section>
      <div class="container">
        <div class="row">
          <div class="col_xl_12 col_l_12 col_m_12 col_s_12">
            <h1 class="tac login_big">Log in</h1>
          </div>

          <div class="col_xl_4 xl_offset_2 col_l_4 l_offset_2 col_m_6 col_s_6">
            <button
                class="colored_btn social_login hover_op first"
                v-on:click="loginWithGoogle"
            >
              Log in w/ Google
            </button>
          </div>

          <div class="col_xl_4 col_l_4 col_m_6 col_s_6">
            <button
                class="colored_btn social_login hover_op last"
                v-on:click="loginWithFacebook"
            >
              Log in w/ Facebook
            </button>
          </div>

          <div class="col_xl_12 col_l_12 col_m_12 col_s_12">
            <p class="tac login_medium">Or</p>
          </div>

          <div
              class="col_xl_8 xl_offset_2 col_l_8 l_offset_2 col_m_12 col_s_12"
          >
            <form v-on:submit="loginWithEmailPassword">
              <div class="row">
                <div class="col_xl_12 col_l_12 col_m_12 col_s_12">
                  <inputWrap
                      :title="'Email address'"
                      :type="'email'"
                      :placeholder="'e.g., edithanderson@gmail.com'"
                      :name="'email'"
                      :id="'email'"
                      :required="true"
                      :inputData.sync="email"
                      :hasError="emailError !== ''"
                      :errorText="emailError"
                  ></inputWrap>
                </div>

                <div class="col_xl_12 col_l_12 col_m_12 col_s_12">
                  <inputWrap
                      :title="'Password'"
                      :type="'password'"
                      :placeholder="'e.g., sfk#211'"
                      :name="'password'"
                      :id="password"
                      :required="true"
                      :inputData.sync="password"
                      :shwoPass="true"
                      :hasError="passwordError !== ''"
                      :errorText="passwordError"
                  ></inputWrap>
                </div>

                <div class="col_xl_12 col_l_12 col_m_12 col_s_12">
                  <div class="df s_betwen login_lover_links_wrap">
                    <router-link
                        :to="signUpLink"
                        class="login_lover_links hover_op"
                    >Don’t have an account?
                    </router-link
                    >
                    <router-link
                        to="/auth/password-reset"
                        class="login_lover_links hover_op"
                    >Forget password?
                    </router-link
                    >
                  </div>
                </div>

                <div class="col_xl_12 col_l_12 col_m_12 col_s_12">
                  <input
                      type="submit"
                      class="color_btn hover_op"
                      value="Log in"
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import inputWrap from "@/components/inputWrap.vue";
import {
  getAuth,
  GoogleAuthProvider,
  FacebookAuthProvider,
  signInWithPopup,
  signInWithEmailAndPassword
} from "firebase/auth";

export default {
  name: "Login",

  data() {
    return {
      email: "",
      password: "",
      emailError: "",
      passwordError: ""
    };
  },

  computed: {
    signUpLink() {
      const returnTo = this.$route.query.returnTo
      return `/auth/sign-up${returnTo ? `?returnTo=${returnTo}` : ''}`
    }
  },

  components: {
    inputWrap,
  },

  methods: {
    async login(fn) {
      try {
        this.emailError = ""
        this.passwordError = ""

        await fn();

        this.$store.commit("setUserAuthenticated", true)
        return this.$router.push(this.$route.query.returnTo ? this.$route.query.returnTo : "/");
      } catch (error) {

        switch (error.code) {
          case "auth/wrong-password":
            this.passwordError = "Wrong password"
            break
          case "auth/user-not-found":
            this.emailError = "No account found with that email address"
            break
          default:
            this.$store.dispatch("onError", "An error occurred");
            console.error(error);
            break
        }

      }
    },

    loginWithGoogle() {
      this.login(() => {
        const provider = new GoogleAuthProvider();
        const auth = getAuth();
        return signInWithPopup(auth, provider)
      });
    },

    loginWithFacebook() {
      this.login(() => {
        const provider = new FacebookAuthProvider();
        const auth = getAuth();
        return signInWithPopup(auth, provider)
      });
    },

    loginWithEmailPassword(event) {
      this.login(() => {
        event.preventDefault();
        const auth = getAuth();
        return signInWithEmailAndPassword(auth, this.email, this.password);
      });
    },
  },
};
</script>
